import { Service } from './service'

export class WebshopService extends Service {
  /**
   * Get all unread notifications
   *
   * @return {ResponseBuilder}
   */
  getTicketDetails (ticketID) {
    return this._apiRequestBuilder.webshop()
      .getDetails(ticketID)
      .json()
      .get()
  }
}

export const webshopService = new WebshopService()



// WEBPACK FOOTER //
// ./src/js/services/webshop.service.js